/* Luhxe Campaign Link Handler  (Shrine PRO)
   Inert unless the URL carries campaign params. Reads:
     lxpromo = discount code (display; cookie is set by the /discount/CODE redirect wrapper)
     lxpct   = percent off (e.g. 10)      -> dynamic price
     lxamt   = cents off  (e.g. 2000)     -> dynamic price
     lxgifts = comma variant ids to auto-add free
     lxnames = pipe-separated gift names for the banner
   Added 2 Sep 2026 (Brian Kim's Loom):
     lxsale    = the SALE NAME, shown as a badge by the title and in the banner, so a
                 campaign link is visibly "National Beach Day Sale" WITHOUT duplicating
                 the product just to rename it. This is the whole point of the tool.
     lxuntil   = ISO datetime the sale ends -> live countdown; after it the campaign
                 goes inert (no gift, no banner) instead of quietly running forever.
     lxfrom    = ISO datetime the sale starts (optional) -> inert before it.
     lxdrop    = comma variant ids to keep OUT of the cart (an app on this store auto-adds
                 a $19 Traveler's Guide nobody asked for; a campaign can refuse it).
     lxgiftfor = comma list of OPTION VALUES the gift applies to (e.g. "Rose,Snow").
     lxgiftper = 1 -> one gift PER qualifying bag in the cart (capped at 10), instead of
                 one per order. Opt-in, so links already sent keep the old behaviour.
                 The gift is added only while the chosen variant matches, and is
                 REMOVED again if they switch to one that does not (Labor Day: free
                 cosmetic bag on pink/white, never on black).
   Shows: (1) a clear "code applied" + "free gift added" banner near the price,
          (2) a dynamic "Your price $X" line, recomputed on variant change.
   Everything is best-effort and wrapped in try/catch; never blocks the page. */
(function () {
  try {
    var q = new URLSearchParams(location.search);
    var promo = q.get('lxpromo');
    var pct = parseFloat(q.get('lxpct') || '0');
    var amt = parseFloat(q.get('lxamt') || '0');
    // Shopify's /discount/CODE?redirect=... does NOT fully decode the inner query, so a
    // value that was encoded before being wrapped arrives still escaped:
    //   lxsale    -> "Labor%20Day%20Sale"
    //   lxgiftfor -> "Rose%2CSnow"   (one token, matches no colour -> gift never applies)
    // Measured 2 Sep 2026 on the live redirect chain. Decode again when the value still
    // looks escaped, so links ALREADY sent out keep working.
    var dec = function (v) {
      v = v || '';
      try { return /%[0-9A-Fa-f]{2}/.test(v) ? decodeURIComponent(v) : v; } catch (e) { return v; }
    };
    var gifts = dec(q.get('lxgifts') || '').split(',').filter(Boolean);
    var sale = dec(q.get('lxsale') || '').trim();
    var giftFor = dec(q.get('lxgiftfor') || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    // lxgiftper=1 -> ONE gift PER qualifying bag in the cart, not one per order.
    // Opt-in on purpose: links already sent out keep the old one-gift behaviour.
    var giftPer = /^(1|true|bag|match|yes)$/i.test(dec(q.get('lxgiftper') || '').trim());
    var GIFT_CAP = 10;   // a $0 line is still a real item to pick and pack
    // lxcopy = "Shoe Bag>>Cosmetic Bag|20 Value>>29 Value"
    // A design carries its own baked copy. The master's bundle tiers say "1x Luhxe Bag +
    // Free Shoe Bag ($20 Value)", so a cosmetic-bag campaign run on that design
    // contradicts itself on the page -- Brian, 2 Sep: "it says free shoebag when we're
    // not giving a free shoebag". No URL param can edit a GemPages design, but the page
    // text can be corrected in place, on campaign links only.
    // lxdrop = comma variant ids to KEEP OUT of the cart on this link. The store has an
    // app that auto-adds a $19 Traveler's Guide the customer never chose, which shows up
    // in a campaign cart as an unexplained charge next to a "free gift". A campaign link
    // can now say what does NOT belong in it.
    var drops = dec(q.get('lxdrop') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var copyRules = dec(q.get('lxcopy') || '').split('|').map(function (p) {
      var i = p.indexOf('>>'); if (i < 0) return null;
      var from = p.slice(0, i).trim(), to = p.slice(i + 2).trim();
      return from ? { from: from, to: to } : null;
    }).filter(Boolean);
    var names = []; // filled from the cart after gifts are added (no fragile name param in the URL)
    if (!promo && !gifts.length && !sale && !copyRules.length && !drops.length) return; // normal traffic: do nothing

    // ---- sale window -------------------------------------------------------
    var parseWhen = function (v) { if (!v) return null; var d = new Date(v); return isNaN(d.getTime()) ? null : d; };
    var startsAt = parseWhen(dec(q.get('lxfrom')));
    var endsAt   = parseWhen(dec(q.get('lxuntil')));
    var now = new Date();
    var notYet = !!(startsAt && now < startsAt);
    var isOver = !!(endsAt && now > endsAt);
    // A sale that has ended must stop behaving like a sale. Silently running a finished
    // campaign is how a store keeps giving away product after the offer is over.
    if (isOver || notYet) {
      try {
        var over = document.createElement('div');
        over.id = 'lx-ended';
        over.style.cssText = 'margin:16px 0;padding:12px 14px;border-radius:8px;background:#f6f4ef;border:1px solid rgba(18,18,18,.12);font:600 13.5px/1.45 inherit;color:#6b6b6b';
        over.textContent = notYet
          ? ((sale || 'This sale') + ' starts ' + startsAt.toLocaleString())
          : ((sale || 'This sale') + ' has ended.');
        var mount = function () { var a = buyAnchor(); if (a && a.parentNode) a.parentNode.insertBefore(over, a); };
        if (document.readyState !== 'loading') mount(); else document.addEventListener('DOMContentLoaded', mount);
      } catch (e) {}
      return; // no gift, no code banner, no price line
    }

    var esc = function (t) { var d = document.createElement('div'); d.textContent = String(t == null ? '' : t); return d.innerHTML; };
    // currency-correct money from cents (customer's active currency, any locale)
    var money = function (c) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(c / 100); }
      catch (e) { return '$' + (c / 100).toFixed(2); }
    };
    // the MAIN product (its variants only) from Shopify's own JSON — prices in cents, active currency
    var PROD = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || null;
    function mainVariantPriceCents() {
      if (!PROD || !PROD.variants || !PROD.variants.length) return 0;
      var ids = {}; PROD.variants.forEach(function (v) { ids[String(v.id)] = v; });
      var chosen = null;
      var uv = new URLSearchParams(location.search).get('variant');
      if (uv && ids[uv]) chosen = ids[uv];
      if (!chosen) { var inp = document.querySelectorAll('[name="id"]'); for (var i = 0; i < inp.length; i++) { if (ids[String(inp[i].value)]) { chosen = ids[String(inp[i].value)]; break; } } }
      if (!chosen) chosen = PROD.variants[0];
      return chosen.price || 0; // cents, active currency
    }

    // which variant is selected right now, and does the gift apply to it?
    function currentVariant() {
      if (!PROD || !PROD.variants || !PROD.variants.length) return null;
      var ids = {}; PROD.variants.forEach(function (v) { ids[String(v.id)] = v; });
      var uv = q.get('variant');
      var sel = new URLSearchParams(location.search).get('variant');
      if (sel && ids[sel]) return ids[sel];
      var inp = document.querySelectorAll('[name="id"]');
      for (var i = 0; i < inp.length; i++) { if (ids[String(inp[i].value)]) return ids[String(inp[i].value)]; }
      return PROD.variants[0];
    }
    // "Rose / Classic" -> ["rose","classic"]
    function variantValues(v) {
      if (!v) return [];
      var t = v.public_title || v.name || '';
      return String(t).split('/').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    }
    // "Rose,Snow" -> "Rose or Snow", in the casing the campaign supplied
    var giftForRaw = dec(q.get('lxgiftfor') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    function giftForLabel() {
      if (giftForRaw.length < 2) return giftForRaw.join('');
      return giftForRaw.slice(0, -1).join(', ') + ' or ' + giftForRaw[giftForRaw.length - 1];
    }
    function giftApplies() {
      if (!giftFor.length) return true;                 // no restriction -> always
      var vals = variantValues(currentVariant());
      for (var i = 0; i < vals.length; i++) { if (giftFor.indexOf(vals[i]) !== -1) return true; }
      return false;
    }

    // How many CAMPAIGN bags are in the cart right now, counting only the variants
    // the gift actually applies to. This is read from the CART, never from the picker,
    // because the customer can put two different colourways in one cart.
    function eligibleBagUnits(cart) {
      if (!PROD || !PROD.variants) return 0;
      var ids = {}; PROD.variants.forEach(function (v) { ids[String(v.id)] = v; });
      var n = 0;
      (cart.items || []).forEach(function (it) {
        var vid = String(it.variant_id || it.id);
        if (gifts.indexOf(vid) !== -1) return;      // never count a gift line as a bag
        var v = ids[vid];
        if (!v) return;                             // a different product entirely
        if (giftFor.length) {
          var vals = variantValues(v), ok = false;
          for (var i = 0; i < vals.length; i++) { if (giftFor.indexOf(vals[i]) !== -1) ok = true; }
          if (!ok) return;
        }
        n += (it.quantity || 0);
      });
      return n;
    }

    // ---- cart write discipline (2 Sep 2026, Brian) -------------------------
    // Brian: "when you try removing the upsell it says this bug" -> "There was an error
    // while updating your cart." Cause: this script was calling /cart/change.js on a
    // 2.5s timer, so when he clicked the trash icon HIS theme and THIS script wrote to
    // the cart in the same moment. Shopify rejects the concurrent write and the theme
    // surfaces that error. Two rules now:
    //   1. every cart write we make goes through ONE promise chain, never in parallel,
    //   2. we back off completely for 4s after ANY cart write we did not make.
    // And we never fight the customer: if they remove one of our gifts, it stays out.
    var CQ = Promise.resolve();                 // our single write queue
    var lastForeignWrite = 0;                   // when the theme/app last wrote
    function quiet() { return Date.now() - lastForeignWrite > 1200; }
    // The bundling app writes to the cart constantly, so a long skip window meant
    // dropUnwanted() backed off forever and the $19 Guide was never removed. The write
    // QUEUE is what stops the "error while updating your cart" race; this is only a
    // short courtesy pause, and anything skipped is retried rather than abandoned.
    function cartWrite(url, body) {
      CQ = CQ.then(function () {
        return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin', body: JSON.stringify(body), __lx: true }).catch(function () {});
      }).then(refreshCartUI);
      return CQ;
    }

    // ⭐ THE ONE THAT CAUSED BRIAN'S "error while updating your cart".
    // This script changes the cart with raw fetch calls, which the THEME never sees, so
    // its server-rendered cart drawer keeps showing the old line list. The drawer's
    // remove buttons are LINE-INDEX based, so a stale/phantom row desynchronises every
    // control below it and Shopify answers "line parameter is invalid".
    // Fix: after any cart write WE make, re-render the theme's own cart sections through
    // Shopify's Section Rendering API, so the drawer is never stale relative to a cart we
    // changed. Verified available on this theme: /?sections=cart-drawer,cart-icon-bubble.
    var SECTIONS = 'cart-drawer,cart-icon-bubble,cart-live-region-text';
    function refreshCartUI() {
      return fetch('/?sections=' + SECTIONS, { credentials: 'same-origin', __lx: true })
        .then(function (r) { return r.json(); })
        .then(function (secs) {
          Object.keys(secs || {}).forEach(function (k) {
            var host = document.getElementById('shopify-section-' + k);
            if (!host || typeof secs[k] !== 'string') return;
            try {
              var doc = new DOMParser().parseFromString(secs[k], 'text/html');
              var fresh = doc.getElementById('shopify-section-' + k);
              host.innerHTML = fresh ? fresh.innerHTML : secs[k];
            } catch (e) {}
          });
          try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
        })
        .catch(function () {});
    }
    // Watch the page's OWN cart writes so we can stand back, and learn what the customer
    // deliberately removed.
    // Deliberate removals are remembered for THIS page view only, deliberately not
    // persisted. Brian: "it worked once but when you retry after deleting it stops
    // working" -- so re-opening the campaign link must restore the offer, while removing
    // the gift mid-visit must not have it shoved back in.
    var REMOVED = [];
    function userRemoved() { return REMOVED; }
    function noteRemoved(v) { if (REMOVED.indexOf(String(v)) === -1) REMOVED.push(String(v)); }
    (function watchCart() {
      var of = window.fetch;
      window.fetch = function (input, init) {
        try {
          var u = String((input && input.url) || input || '');
          if (/\/cart\/(change|update|add|clear)/.test(u) && !(init && init.__lx)) {
            lastForeignWrite = Date.now();
            try { document.dispatchEvent(new CustomEvent('lx:foreign-cart-write')); } catch (e) {}
            setTimeout(function () { if (gifts.length) refreshCartState(); }, 900);
            // did the customer zero one of OUR gifts?
            var b = init && init.body;
            if (typeof b === 'string' && /"quantity"\s*:\s*0/.test(b)) {
              gifts.forEach(function (g) { if (b.indexOf(g) !== -1) noteRemoved(g); });
            }
          }
        } catch (e) {}
        return of.apply(this, arguments);
      };
    })();

    // 1) make sure the discount is really on the session (cookie) at checkout
    if (promo) { try { fetch('/discount/' + encodeURIComponent(promo), { credentials: 'same-origin' }).catch(function () {}); } catch (e) {} }

    // 2) add the free gifts to the cart once (skip any already in cart), then read their names from the cart
    var giftsInCart = false;   // what the CART says, never what we hoped
    var cartRead = false;      // have we successfully READ the cart even once?
    function namesFromCart(cart) {
      var byId = {}; (cart.items || []).forEach(function (it) { byId[String(it.variant_id || it.id)] = (it.product_title || it.title || '').split(' - ')[0]; });
      names = gifts.map(function (v) { return byId[v]; }).filter(Boolean);
      giftsInCart = names.length > 0;
      cartRead = true;
      banner(true); giftNote(); // re-render with real gift names
    }
    function refreshCartState() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(namesFromCart).catch(function () {});
    }
    // Add the gift when the chosen variant qualifies, and take it back out when it does
    // not. Only ADDING would mean a customer picks Rose, gets the free bag, switches to
    // black, and still checks out with it -- exactly the case Brian ruled out.
    var syncing = false;
    function syncGifts() {
      if (!gifts.length || syncing) return;
      syncing = true;
      var wanted = giftApplies();
      if (!quiet()) { syncing = false; setTimeout(syncGifts, 1400); return; }   // retry, never abandon
      var removed = userRemoved();
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var have = {}; (cart.items || []).forEach(function (it) { have[String(it.variant_id || it.id)] = true; });
        if (wanted) {
          var haveQty = {};
          (cart.items || []).forEach(function (it) { haveQty[String(it.variant_id || it.id)] = it.quantity || 0; });
          // How many of each gift we want. Default 1 per order. With lxgiftper, one per
          // qualifying bag -- and still 1 before the customer has added anything, so the
          // gift is visible on the page the way it always was.
          var want = 1;
          if (giftPer) {
            var units = eligibleBagUnits(cart);
            want = units > 0 ? Math.min(units, GIFT_CAP) : 1;
          }
          var toAdd = [], toSet = [];
          gifts.forEach(function (v) {
            if (removed.indexOf(String(v)) !== -1) return;   // they took it out on purpose
            var cur = haveQty[String(v)] || 0;
            if (cur < want) toAdd.push({ id: Number(v), quantity: want - cur });
            else if (cur > want) toSet.push({ id: String(v), quantity: want });
          });
          if (!toAdd.length && !toSet.length) { syncing = false; return namesFromCart(cart); }
          var addChain = Promise.resolve();
          if (toAdd.length) addChain = addChain.then(function () { return cartWrite('/cart/add.js', { items: toAdd }); });
          toSet.forEach(function (s) { addChain = addChain.then(function () { return cartWrite('/cart/change.js', { id: s.id, quantity: s.quantity }); }); });
          return addChain
            .then(function () { document.dispatchEvent(new CustomEvent('lx:gifts-added')); return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
            .then(function (c) { syncing = false; namesFromCart(c); });
        }
        // not eligible -> remove any of OUR gift lines that are in the cart
        var toDrop = gifts.filter(function (v) { return have[v]; });
        if (!toDrop.length) { syncing = false; names = []; banner(true); return; }
        var chain = Promise.resolve();
        toDrop.forEach(function (v) { chain = chain.then(function () { return cartWrite('/cart/change.js', { id: String(v), quantity: 0 }); }); });
        return chain.then(function () { syncing = false; names = []; banner(true); });
      }).catch(function () { syncing = false; });
    }
    if (gifts.length) syncGifts();
    // The gift count only tracks the bag count if we re-check after the customer adds
    // bags. We do NOT depend on detecting their write: the foreign-write watcher only
    // patches window.fetch, and this store's bundle app does not add to cart that way,
    // so the event never fires here. Measured: 2 bags, 1 gift.
    // Instead reconcile on a bounded READ-ONLY poll. syncGifts GETs /cart.js first and
    // only writes when the quantity is actually wrong, so a tick costs one GET and a GET
    // cannot cause the write race that produced Brian's "error while updating your cart".
    if (gifts.length && giftPer) {
      var perTicks = 0, perTimer = setInterval(function () {
        if (perTicks++ > 60) { clearInterval(perTimer); return; }   // ~3 minutes, then stop
        syncGifts();
      }, 3000);
      document.addEventListener('lx:foreign-cart-write', function () { setTimeout(syncGifts, 900); });
      document.addEventListener('lx:gifts-added', function () { setTimeout(syncGifts, 1500); });
      window.addEventListener('pagehide', function () { try { clearInterval(perTimer); } catch (e) {} });
    }

    // Keep the unwanted lines out. The app re-adds on its own schedule, so this watches
    // rather than firing once. Only ever touches ids the campaign explicitly listed.
    var dropping = false, dropTries = 0;
    function dropUnwanted() {
      if (!drops.length || dropping) return;
      if (!quiet()) { setTimeout(dropUnwanted, 1400); return; }   // retry, never abandon
      dropping = true;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var present = {}; (cart.items || []).forEach(function (it) { present[String(it.variant_id || it.id)] = true; });
        var hit = drops.filter(function (v) { return present[v]; });
        if (!hit.length) { dropping = false; return; }
        var chain = Promise.resolve();
        hit.forEach(function (v) { chain = chain.then(function () { return cartWrite('/cart/change.js', { id: String(v), quantity: 0 }); }); });
        return chain.then(function () { dropping = false; document.dispatchEvent(new CustomEvent('lx:dropped')); });
      }).catch(function () { dropping = false; });
    }
    if (drops.length) {
      // Event driven, not a blind timer: the app adds the Guide when the customer clicks
      // Add to Cart, which is long after page load. React to cart writes we observe.
      dropUnwanted();
      document.addEventListener('lx:gifts-added', function () { setTimeout(dropUnwanted, 700); });
      document.addEventListener('lx:foreign-cart-write', function () {
        if (dropTries++ < 40) setTimeout(dropUnwanted, 900);
      });
    }

    function isVisible(el){ return !!(el && el.offsetParent !== null && el.getClientRects().length); }
    function okAnchor(el){ if(!isVisible(el))return false; var r=el.getBoundingClientRect(); return r.height>8 && r.height<320 && r.width<900; } // reject giant wrapping forms
    function buyAnchor(){
      // 1) the actual add-to-cart BUTTON (native + GemPages/custom), a small element
      var btnSels=['button[name="add"]','.product-form__submit','button.gp-button-atc','.gp-button-atc','button[class*="add-to-cart"]','button[class*="AddToCart"]','[class*="add-to-cart"] button','.shopify-payment-button__button'];
      for(var s=0;s<btnSels.length;s++){var els=document.querySelectorAll(btnSels[s]);for(var i=0;i<els.length;i++){if(okAnchor(els[i]))return els[i];}}
      // 2) any visible clickable labelled "add to cart"
      var clk=document.querySelectorAll('button,a,[role="button"],.gp-button');
      for(var j=0;j<clk.length;j++){var t=(clk[j].textContent||'').replace(/\s+/g,' ').trim();if(t.length<40&&/add to (cart|bag)/i.test(t)&&okAnchor(clk[j]))return clk[j];}
      // 3) native button group, reasonably sized
      var pg=document.querySelectorAll('.product-form__buttons');for(var k=0;k<pg.length;k++){if(okAnchor(pg[k]))return pg[k];}
      // 4) visible price fallback (never the hidden native price / giant wrapper)
      var pcs=document.querySelectorAll('.price__container,.price');for(var m=0;m<pcs.length;m++){if(okAnchor(pcs[m]))return pcs[m];}
      return null;
    }

    // 3) banner near the price / buy button
    function banner(force) {
      var existing = document.getElementById('lx-banner');
      if (existing && !force) return;
      var b = existing || document.createElement('div');
      b.id = 'lx-banner';
      b.style.cssText = 'margin:16px 0;padding:14px 16px;border-radius:8px;background:#f6f4ef;border:1px solid rgba(18,18,18,.12);font-family:inherit;line-height:1.45;color:#121212';
      var h = '';
      if (sale) {
        h += '<div style="font:700 11px/1 inherit;letter-spacing:1.1px;text-transform:uppercase;color:#8a6d3b;margin-bottom:9px;">' + esc(sale) + '</div>';
      }
      if (promo) {
        var off = pct ? (pct + '% off') : amt ? (money(amt) + ' off') : '';
        h += '<div style="display:flex;align-items:flex-start;gap:9px;font-size:14px;font-weight:600;color:#121212;letter-spacing:.2px;">' +
               '<span style="display:inline-flex;align-items:center;justify-content:center;width:19px;height:19px;border-radius:50%;background:#121212;color:#fff;font-size:11px;flex:0 0 auto;margin-top:1px;">&#10003;</span>' +
               '<span>Code <b>' + promo + '</b> applied' + (off ? ', ' + off : '') + '. Nothing to type at checkout.</span></div>';
      }
      if (!promo && gifts.length) {
        h += '<div style="display:flex;align-items:flex-start;gap:9px;font-size:14px;font-weight:600;color:#121212;letter-spacing:.2px;">' +
               '<span style="display:inline-flex;align-items:center;justify-content:center;width:19px;height:19px;border-radius:50%;background:#121212;color:#fff;font-size:11px;flex:0 0 auto;margin-top:1px;">&#10003;</span>' +
               '<span>Your gift is already in the cart. <b>Nothing to enter at checkout.</b></span></div>';
      }
      if (gifts.length) {
        var eligible = giftApplies();
        var gn = names.length ? names.join(', ') : (gifts.length + ' free gift' + (gifts.length > 1 ? 's' : ''));
        var pad = 'margin-top:' + (promo ? '7px' : '0') + ';padding-left:' + (promo ? '28px' : '0') + ';';
        if (eligible && giftsInCart) {
          h += '<div style="font-size:13px;color:#5b5b5b;' + pad + 'letter-spacing:.2px;">Free gift' + (gifts.length > 1 ? 's' : '') + ' added: ' + esc(gn) +
               (giftFor.length ? ' <span style="color:#8a6d3b;">\u2014 on ' + esc(giftForLabel()) + ' only</span>' : '') + '</div>';
        } else if (eligible && cartRead) {
          // eligible but not in the cart (the customer removed it). Say so honestly.
          // Gated on cartRead: before the first cart read we do not KNOW it is absent,
          // and saying so contradicts the line directly above it.
          h += '<div style="font-size:13px;color:#8a6d3b;' + pad + 'letter-spacing:.2px;">Your free gift'
             + (giftFor.length ? ' (on ' + esc(giftForLabel()) + ')' : '') + ' is not in the cart \u2014 reload this page to add it back.</div>';
        } else if (!eligible) {
          h += '<div style="font-size:13px;color:#8a6d3b;' + pad + 'letter-spacing:.2px;">The free gift applies to <b>' + esc(giftForLabel()) + '</b> only \u2014 pick one of those to get it.</div>';
        }
      }
      if (endsAt) {
        h += '<div id="lx-countdown" style="font-size:12.5px;color:#5b5b5b;margin-top:8px;padding-left:' + (promo ? '28px' : '0') + ';letter-spacing:.2px;"></div>';
      }
      b.innerHTML = h;
      if (existing) return; // already placed; we only refreshed its contents
      var a = buyAnchor();
      if (a && a.parentNode) a.parentNode.insertBefore(b, a);
      else document.body.insertBefore(b, document.body.firstChild);
    }

    // 4) dynamic "Your price" line from the product JSON (currency-correct, updates on variant change)
    function priceLine() {
      if (!promo || (!pct && !amt)) return;
      var orig = mainVariantPriceCents();
      if (!orig) return;
      var disc = pct ? Math.round(orig * (1 - pct / 100)) : Math.max(0, orig - amt);
      var box = document.getElementById('lx-price');
      if (box && box.getAttribute('data-v') == String(disc)) return; // unchanged -> stop (no observer loop)
      if (!box) {
        box = document.createElement('div'); box.id = 'lx-price';
        box.style.cssText = 'margin:14px 0 2px;font-family:inherit;display:flex;align-items:baseline;gap:10px;flex-wrap:wrap;';
        var a = buyAnchor();
        if (a && a.parentNode) a.parentNode.insertBefore(box, a); else return;
      }
      box.setAttribute('data-v', String(disc));
      box.innerHTML = '<span style="font-size:14px;color:#9a9a9a;">Regular <s>' + money(orig) + '</s></span>' +
        '<span style="font-size:15px;color:#121212;">Your price <b style="font-size:22px;font-weight:700;letter-spacing:.3px;">' + money(disc) + '</b></span>' +
        '<span style="align-self:center;font-size:10.5px;font-weight:700;letter-spacing:.9px;text-transform:uppercase;background:#121212;color:#fff;padding:3px 8px;border-radius:4px;">' + promo + '</span>';
    }

    // Put the sale name where a duplicated product used to carry it: right by the title.
    function saleBadge() {
      if (!sale || document.getElementById('lx-sale')) return;
      var h1 = document.querySelector('h1');
      if (!h1) return;
      var d = document.createElement('div');
      d.id = 'lx-sale';
      d.textContent = sale;
      d.style.cssText = 'display:inline-block;margin:0 0 8px;padding:5px 11px;border-radius:999px;background:#121212;color:#fff;font:700 10.5px/1 inherit;letter-spacing:1.2px;text-transform:uppercase;';
      h1.parentNode.insertBefore(d, h1);
      try { if (document.title.indexOf(sale) === -1) document.title = sale + ' \u00b7 ' + document.title; } catch (e) {}
      // "all around the page" (Brian): also the announcement bar and any sticky buy bar,
      // which are the two places the duplicated products used to carry the sale name.
      try {
        // This theme's top marquee is `.horizontal-ticker`, NOT `.announcement-bar__message`
        // (measured on the live page 2 Sep). It repeats its items, so inject a copy of the
        // sale name into EVERY ticker container to keep the loop even.
        var conts = document.querySelectorAll('.horizontal-ticker__container');
        if (conts.length) {
          for (var ci = 0; ci < conts.length; ci++) {
            if (conts[ci].querySelector('.lx-ann')) continue;
            var proto = conts[ci].querySelector('.horizontal-ticker__item');
            var it = proto ? proto.cloneNode(true) : document.createElement('div');
            it.className = (proto ? proto.className + ' ' : '') + 'lx-ann';
            it.textContent = sale;
            it.style.cssText = 'font-weight:800;letter-spacing:.6px;';
            conts[ci].appendChild(it);
          }
        } else {
          var ann = document.querySelector('.announcement-bar__message, .announcement-bar, [class*="announcement"] [class*="message"]');
          if (ann && !ann.querySelector('.lx-ann')) {
            var sp = document.createElement('span'); sp.className = 'lx-ann';
            sp.textContent = ' \u00b7 ' + sale + ' \u00b7 ';
            sp.style.cssText = 'font-weight:800;letter-spacing:.6px;';
            ann.appendChild(sp);
          }
        }
        var sticky = document.querySelector('[class*="sticky"][class*="atc"], [class*="sticky-cart"], [class*="stickyBar"], .gp-sticky');
        if (sticky && !sticky.querySelector('.lx-sticky')) {
          var st = document.createElement('div'); st.className = 'lx-sticky';
          st.textContent = sale;
          st.style.cssText = 'font:700 10.5px/1 inherit;letter-spacing:1.1px;text-transform:uppercase;color:#8a6d3b;padding:4px 0;';
          sticky.insertBefore(st, sticky.firstChild);
        }
      } catch (e) {}
    }

    function tick() {
      var el = document.getElementById('lx-countdown');
      if (!el || !endsAt) return;
      var ms = endsAt - new Date();
      if (ms <= 0) { el.textContent = 'This sale has ended.'; return; }
      var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), ss = s % 60;
      el.innerHTML = 'Ends in <b>' + (d ? d + 'd ' : '') + h + 'h ' + m + 'm ' + ss + 's</b>';
    }

    // Walk visible text nodes and correct the design's baked copy. Text nodes only, so
    // no markup, attributes or scripts are touched.
    function applyCopy() {
      if (!copyRules.length) return;
      var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, svg: 1 };
      var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var n, hits = 0;
      while ((n = w.nextNode())) {
        if (!n.nodeValue || !n.nodeValue.trim()) continue;
        if (n.parentNode && SKIP[n.parentNode.nodeName]) continue;
        var before = n.nodeValue, after = before;
        for (var i = 0; i < copyRules.length; i++) {
          var r = copyRules[i];
          if (after.toLowerCase().indexOf(r.from.toLowerCase()) === -1) continue;
          after = after.replace(new RegExp(r.from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'), r.to);
        }
        if (after !== before) { n.nodeValue = after; hits++; }
      }
      return hits;
    }

    // The theme's variant picker rewrites the URL to ?variant=... and drops the campaign
    // params, so a REFRESH after switching colour lost the whole campaign. Put them back
    // on every history write.
    function keepParams() {
      var KEYS = ['lxpromo','lxpct','lxamt','lxgifts','lxsale','lxfrom','lxuntil','lxgiftfor','lxcopy','lxdrop','lxgiftper'];
      var mine = {};
      KEYS.forEach(function (k) { var v = q.get(k); if (v !== null) mine[k] = v; });
      if (!Object.keys(mine).length) return;
      var restore = function () {
        try {
          var u = new URL(location.href), changed = false;
          Object.keys(mine).forEach(function (k) { if (!u.searchParams.has(k)) { u.searchParams.set(k, mine[k]); changed = true; } });
          if (changed) history.replaceState(history.state, '', u.toString());
        } catch (e) {}
      };
      ['pushState', 'replaceState'].forEach(function (m) {
        var orig = history[m];
        history[m] = function () { var r = orig.apply(this, arguments); setTimeout(restore, 0); return r; };
      });
      window.addEventListener('popstate', restore);
      setInterval(restore, 1200);
      restore();
    }

    // Brian: "we might even want to add copy in the PDP itself to mention that it only
    // applies for Rose and Snow". Put it where the choice is made, not only in the banner.
    function giftNote() {
      if (!giftFor.length || !gifts.length) return;
      // The master's theme page has a native swatch picker; the GemPages sales page has a
      // Kaching combobox instead and matches none of those selectors, so the note simply
      // never rendered there. Fall back to sitting above the buy button, which every
      // design has.
      var host = document.querySelector('[data-id*="options-Color"], variant-radios, variant-selects, .product-form__input, fieldset')
                 || buyAnchor();
      if (!host || !host.parentNode) return;
      var n = document.getElementById('lx-giftnote');
      var txt = 'Free ' + (names.length ? names.join(', ') : 'gift') + ' on ' + giftForLabel() + ' only';
      if (n) { if (n.getAttribute('data-t') !== txt) { n.textContent = txt; n.setAttribute('data-t', txt); } return; }
      n = document.createElement('div');
      n.id = 'lx-giftnote';
      n.setAttribute('data-t', txt);
      n.textContent = txt;
      n.style.cssText = 'margin:8px 0 2px;font:700 11.5px/1.4 inherit;letter-spacing:.3px;color:#8a6d3b;';
      host.parentNode.insertBefore(n, host);
    }

    // The banner must always describe the REAL cart. A read-only /cart.js poll cannot
    // cause the concurrent-write problem, and it catches cart edits the theme makes by
    // XHR or a form post, which the fetch watcher cannot see.
    if (gifts.length) setInterval(function () { refreshCartState(); }, 4000);

    function run() { saleBadge(); banner(); priceLine(); tick(); applyCopy(); giftNote(); }
    keepParams();
    // the design lazy-renders, so re-apply the copy fix as blocks arrive
    try { var _cm = new MutationObserver(function () { applyCopy(); }); _cm.observe(document.body, { subtree: true, childList: true }); } catch (e) {}
    if (endsAt) setInterval(tick, 1000);
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    // re-price when the customer switches colour / size
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-radios, variant-selects, form[action="/cart/add"], .product-form, product-form')) {
        setTimeout(priceLine, 60);
        // Brian: after deleting the gift, switching back to Rose left it out AND the
        // banner still said "Free gift added". Picking a different variant is a new
        // choice, so the earlier removal no longer applies.
        REMOVED.length = 0;
        if (giftFor.length) setTimeout(function () { syncGifts(); banner(true); giftNote(); }, 120);
      }
    }, true);
    document.addEventListener('lx:gifts-added', function () {});
    try { new MutationObserver(function () { priceLine(); }).observe(document.body, { subtree: true, childList: true, characterData: true }); } catch (e) {}
  } catch (e) {}
})();

